var exports = {
  "GE": "AvatarStack__PCp_NM",
  "d6": "clickableAvatarWrapper__e_Z4Tc",
  "br": "assigneeStackWrapper__CaAKb0",
};

module.exports = exports;
